import axios from 'axios'
import {getAuthToken} from "@/utils/auth";
import {
  isBrowserOffline,
  isOfflineError,
  markOffline,
  markOnline,
  offlineError,
  reportBlockedRequest,
} from "@/utils/network";

const token = getAuthToken();
axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
axios.defaults.headers.common['Accept-Language'] = localStorage.getItem('selectedLocale') || 'en';
axios.defaults.headers.common['Content-Type'] = 'application/json';

/*
 * Toute l'application passe par cette instance d'axios : `utils/services.js`
 * n'en crée aucune autre. Les deux intercepteurs ci-dessous sont donc le seul
 * endroit où surveiller la connexion, quel que soit l'écran ou l'appel.
 */

/*
 * Requête tentée sans réseau : on ne l'envoie pas.
 *
 * L'attendre ne mènerait qu'à un long silence suivi d'une erreur obscure —
 * c'est exactement ce qui faisait tomber le formulaire d'ajout d'élève sur un
 * message incompréhensible. L'échec est immédiat, porte la marque
 * `isNetworkError`, et la carte « pas de connexion » revient à l'écran.
 *
 * Le blocage ne joue que si le système affirme qu'aucun réseau n'est
 * disponible. Une coupure déduite d'une requête échouée, elle, ne bloque
 * rien : la requête suivante doit pouvoir réussir et rétablir l'état.
 */
axios.interceptors.request.use((config) => {
  if (isBrowserOffline()) {
    reportBlockedRequest();
    return Promise.reject(offlineError(config));
  }
  return config;
});

axios.interceptors.response.use(
  (response) => {
    // Le serveur a répondu : la connexion est là, quoi qu'on ait cru avant.
    markOnline();
    return response;
  },
  (error) => {
    if (isOfflineError(error)) {
      // Marque l'erreur pour que les écrans distinguent « pas de connexion »
      // d'un refus du serveur, et parlent en conséquence.
      error.isNetworkError = true;
      markOffline({ announce: true });
    } else if (error && error.response) {
      markOnline();
    }
    return Promise.reject(error);
  }
);
